import React from 'react';

const PrevArrow = (props) => <span className="slick-prev" onClick={props.onClick}><i className="fa fa-angle-left"/></span>;

export default PrevArrow;